import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import { useOrderGrowth } from '@hooks/dashboard/useKapi';
import { OrderData } from 'types/dashboard/dashboardTypes';

const BarGraph: React.FC = () => {
  const { data: orders, isLoading } = useOrderGrowth();

  if (isLoading) return <div className="chart-loading">Loading chart...</div>;

  const chartData = orders ? orders.map((item: OrderData) => ({
    date: item.date,
    totalOrders: item.totalOrders,
  })) : Array.from({ length: 30 }, (_, i) => ({ date: `Day ${i + 1}`, totalOrders: 0 }));

  return (
    <ResponsiveContainer width="100%" height={320}>
      <BarChart data={chartData} margin={{ top: 10, right: 10, left: 0, bottom: 0 }}>
        <defs>
          <linearGradient id="orderBarGrad" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#F59E0B" stopOpacity={0.9}/>
            <stop offset="100%" stopColor="#F59E0B" stopOpacity={0.4}/>
          </linearGradient>
        </defs>
        <CartesianGrid strokeDasharray="3 3" stroke="#F3F4F6" vertical={false} />
        <XAxis dataKey="date" tick={{ fontSize: 11, fill: '#9CA3AF' }} axisLine={false} tickLine={false} />
        <YAxis tick={{ fontSize: 11, fill: '#9CA3AF' }} axisLine={false} tickLine={false} />
        <Tooltip
          contentStyle={{ background: '#0B1829', border: 'none', borderRadius: 10, color: '#fff', fontSize: 12, boxShadow: '0 8px 24px rgba(0,0,0,0.2)' }}
          labelStyle={{ color: '#84EEFC', fontWeight: 600, marginBottom: 4 }}
          itemStyle={{ color: '#fff' }}
          cursor={{ fill: 'rgba(245,158,11,0.05)' }}
        />
        <Bar dataKey="totalOrders" fill="url(#orderBarGrad)" radius={[4, 4, 0, 0]} maxBarSize={32} />
      </BarChart>
    </ResponsiveContainer>
  );
};

export default BarGraph;